module.exports = __webpack_public_path__ + "img/forgot_password.37799cce.svg";